import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { FaSignOutAlt, FaUserCircle, FaBars } from 'react-icons/fa';

const Header = ({ onToggleSidebar }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const onLogout = () => {
        logout();
        navigate('/login');
    };

    const currentDate = new Date().toLocaleDateString('fr-FR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    return (
        <header className="dashboard-header">
            <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <button
                    className="btn-icon mobile-menu-toggle"
                    onClick={onToggleSidebar}
                    style={{ fontSize: '1.2rem', color: 'var(--primary-color)' }}
                >
                    <FaBars />
                </button>
                <div className="welcome-text">
                    <h1>
                        Salam, <span>{user ? user.name : 'Invité'}</span>
                    </h1>
                    <p className="date-display">{currentDate}</p>
                </div>
            </div>

            <div className="user-actions">
                {user && (
                    <button className="btn btn-secondary" onClick={onLogout}>
                        <FaSignOutAlt /> <span className="logout-text">Déconnexion</span>
                    </button>
                )}
            </div>
        </header>
    );
};

export default Header;
